import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TOKENS } from '../constants';

/**
 * Corner ribbon-style badge anchored to the card's top-right edge. Relies on
 * the card having `overflow: hidden` and `position: relative` so the top-right
 * corner clips against the card's outer radius.
 */
export const FirstTimeBadge = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <HStack
      css={`
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        background-color: ${TOKENS.firstTimeBg};
        border-bottom-left-radius: ${rpx(8)}px;
        padding: ${rpx(2)}px ${rpx(7)}px;
        align-items: center;
      `}
    >
      <Typography.Text
        size={rpx(8)}
        color={TOKENS.firstTimeText}
        lineHeight={rpx(10)}
      >
        ★
      </Typography.Text>
      <Typography.Label
        size={rpx(9.5)}
        lineHeight={rpx(12)}
        color={TOKENS.firstTimeText}
        css={`
          margin-left: ${rpx(3)}px;
        `}
      >
        首次到店
      </Typography.Label>
    </HStack>
  );
});
